<script>
import controller from './controller'
const { script } = controller()
export default script
</script>

<template>
  <b-table responsive
           stacked="sm"
           no-border-collapse
           small
           hover
           :items="items"
           :fields="fields">
  </b-table>
</template>

<style lang="scss" src="./styles.scss" />